import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getAllRoleAssignments = async () => {
  try {
    const resp = await apiClient.get(`/systemInvoiceRoleManagement/all`, {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
